'use strict';
const _ = require('underscore'),
	mmWidgets = require('./mm-widgets');

mmWidgets.fn.progressProjectionsWidget = function (progressModel) {
	return mmWidgets.each(this, function () {
		const element = this,
			template = element.find('[data-mm-role=projection-template]').detach().attr('data-mm-role', ''),
			setProjections = function (projections) {
				element.empty();
				_.each(projections, function (projection) {
					const item = template.clone().appendTo(element);
					item.text(projection).val(projection);
				});
			};
		progressModel.addEventListener('projectionsChanged', setProjections);

		element.on('change', function () {
			progressModel.setActiveProjection(element.val());
		});
	});
};
